export const keywordTooltip = (
  <div>
    Nyckelord är kopplade till ett tekniskt system eller tjänsteområde. När du
    väljer ett nyckelord fylls fältet för tekniskt system eller tjänsteområde
    automatiskt i med det tjänsteområde eller teniskt system som är kopplat till
    nyckelordet.
  </div>
);

export const systemRadioTooltip = (
  <div>
    <strong>Tjänsteområde</strong> – Betyder att endast befintliga
    tjänsteområden blir valbara, endast valt tjänsteområdes FAQ:er presenteras.
  </div>
);

export const operationRadioTooltip = (
  <div>
    <strong>Tekniskt system</strong> - Betyder att endast befintliga tekniska
    system blir valbara, endast valt tekniskt systems FAQ:er presenteras.
  </div>
);

export const allSectionsRadioTooltip = (
  <div>
    <strong>Alla</strong> – Betyder att samtliga tjänsteområden och tekniska
    system blir valbara, endast valt tjänsteområde eller tekniskt systems FAQ:er
    presenteras.
  </div>
);

export const showConnectedSectionsTooltip = (
  <div>
    Markera den här rutan för att visa alla kopplade tjänsteområden eller
    tekniska system till det valda tjänsteområdet / tekniska systemet.
  </div>
);

export const questionTypeTooltip = (
  <div>
    Detta är en etikett som anger vilken sorts fråga eller ärende du har (t.ex.
    avvikelse eller förbättringsförslag).
  </div>
);

export const sectionTooltip = (
  <div>
    Tjänsteområde/tekniskt system är interna kategorier avgör vilken avdelning
    som ansvarar för ditt ärende. Ett tjänsteområde beskriver
    verksamhetsområdet, medan ett tekniskt system avser ett IT-relaterat område.
    Välj det alternativ som passar bäst.
  </div>
);

export const clientTypeTooltip = (
  <div>Här kan du välja vilken avdelning/organisation/målgrupp du tillhör.</div>
);

export const searchTooltip = (
  <div>
    Sök letar efter ord i samtliga FAQ:ers <i>"Rubrik"</i>, <i>"Fråga"</i> eller{" "}
    <i>"Svar"</i>.
  </div>
);
